// frontend/src/pages/RegisterPage.jsx
// 使用者註冊頁面

import { Container, Box, Typography, Paper, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Register from '../components/Auth/Register';

const RegisterPage = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: '100%',
            borderRadius: 2,
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 1 }}>
            BuddhaSearch
          </Typography>
          <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 3 }}>
            申請帳號
          </Typography>

          <Register />

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              已有帳號？{' '}
              <Link component={RouterLink} to="/login" underline="hover">
                立即登入
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default RegisterPage;
